import { DialogContentText, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Tooltip } from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
//import "./ComplaintsList.scss";
import { TextField } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import MaterialTable from "material-table";
import { CircularProgress } from "@material-ui/core";
import { BootstrapInput, getTodayDateMoment, tableIcons } from "../../Utilities/Utility";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
//import { BootstrapInput, getTodayDateMoment, tableIcons } from "../../../Utilities/Utility";
import moment from "moment";
import Loading from ".././../Components/Loader/Loader";
import Button from "@material-ui/core/Button";
import { getAllIsirDetails, getComponentEngiDetailsList, getGroupcategory, GetISIRKPIDetails, getsqeDetailsList, getSupplierlist } from "../../Redux/APIs/api_view";
import * as XLSX from "xlsx";
//import { BootstrapInput } from "../../Utilities/Utility";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined } from "@material-ui/icons";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AddIsirRoot from "../ADDISIR/AddIsirRoot";
import AddIsir from "../ADDISIR/AddlSir";
import { deleteComplaintsRecord, deleteISIRRecord } from "../../Redux/APIs/api_MasterData";
import SnackbarCustom from "../../Components/Snackbar/Snackbar";
import { getSupplierDDL } from "../../Redux/APIs/api_Common";
//import { supplierMailValAction } from "../../../Redux/Actions/actions";

const Epwork = () => {
    const dispatch = useDispatch();
    const tableRef = useRef();
    const token = useSelector((state) => state.saveTokenReducer.token);
    const userDetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
    const storedSupplierMailArr = useSelector((state) => state.supplierEmailArrReducer);
    const [isirDetailsData, setIsirDetailsData] = useState([]);
    const [open, setOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const [isLoaderKpi, setIsLoaderKpi] = useState(false);
    const [isLoaderFeedback, setIsLoaderFeedback] = useState(false);
    const navigate = useNavigate();
    const [dateInputs, setDateInputs] = useState({
        fromDate: null,
        toDate: null
    });
    //azure ad
    const siteToken = useSelector((state) => state.saveBearerTokenReducer);
    const azureToken = useSelector((state) => state.saveTokenReducer);
    const UID = useSelector((state) => state.saveUserIdReducer);
    function handleDateChange(event, value) {
        let elem = event.target.name;
        switch (elem) {
            case "fromDate":
                setDateInputs({
                    ...dateInputs,
                    fromDate: event.target.value,
                })
                break;
            case "toDate":
                setDateInputs({
                    ...dateInputs,
                    toDate: event.target.value,
                })
                break;
            default:
                break;

        }
    }

    function navigateToComplaintsPage(data) {
        // supplierId

        return (
            <Button
                className="pt-button--light"
                onClick={() => {
                    // console.log("Tab Data", data);
                    //const supMailIndex = findDefSupplerMailIdx(data);
                    //dispatch(supplierMailValAction(supMailIndex));
                    navigate("/AddIsir", {
                        state: {
                            rowData: data
                        }
                    });
                }}
            >
                {data.automatedIsirnumber} {/*automatedIsirnumber   {data.complaintNumber}*/}
            </Button>
        );
    }
    function renderDateY(value) {
        let DateFormat = !value ? null : moment(value).format('MM/DD/YYYY');
        return DateFormat;

    }
    //function findDefSupplerMailIdx(arg) {
    //console.log("Index", defaIndex);
    ///return storedSupplierMailArr.findIndex(x => x.supplierId == arg.supplierId && x.email == arg.supplierEmail);
    //setDefaIndex(defaIndexVal);
    //}
    function renderDate(value) {
        let DateFormat = !value ? null : moment(value).format('YYYY-MM-DD');
        return DateFormat;
    }
    const tableHeaderStyle = {
        backgroundColor: "var(--light-sand)",
        color: "var(--dark-blue)",
    };
    const icon = () => {
        return (
            <GetAppRoundedIcon
                style={{ fontSize: 45, }}
            />
        );
    };
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteRowData, setDeleteRowData] = useState(null);
    function GetDeleteButton() {
        return (
            <Tooltip title="Delete" placement="bottom">
                <span>
                    <Button href="javascript:void(0)">
                        <span>
                            <DeleteOutlined fontSize="small" className="attachFileIcon" />
                        </span>
                    </Button>
                </span>
            </Tooltip>
        );
    }
    const handleDeleteIconClick = (rowData) => {
        setDeleteRowData(rowData);
        setDeleteDialogOpen(true);
    };
    const handleCloseDeleteDialog = () => {
        setDeleteDialogOpen(false);
        setDeleteRowData(null);
    };
    const handleDialogRowDelete = () => {
        setIsLoader(true);
        setIsLoaderFeedback(true);
        setDeleteDialogOpen(false);
        const deleteArgs = deleteRowData;

        deleteISIRRecord(siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId, deleteArgs)
            .then((response) => {
                if (response.response) {
                    handleSnackOpen(response.responseMsg, "success");
                    setIsLoader(false);
                    setIsLoaderFeedback(false);
                    getDetailsForIsir();
                } else {
                    handleSnackOpen(response.responseMsg, "error");
                    setIsLoader(false);
                    setIsLoaderFeedback(false);
                }
            })
            .catch((error) => {
                handleSnackOpen("Exception : " + error, "error");
                setIsLoader(false);
            });

    };
    const actions = [
        {
            icon: icon,
            tooltip: "Export to Excel",
            onClick: () => ExportToExcel(),
            isFreeAction: true,
        },
        {
            icon: GetDeleteButton,
            tisFreeAction: true,
            onClick: (e, rowData) => {
                console.log("Row Data", rowData);
                handleDeleteIconClick(rowData);
            },
        },
    ];
    var columns = [
        {
            title: "ISIR ID",
            field: "automatedIsirnumber",
            render: (rowData) => navigateToComplaintsPage(rowData),
        },
        {
            title: "Spiridon No",
            field: "spiridonNumber",
            //render: (rowData) => <span>{renderPartValue(rowData.partId)}</span>
        },
        {
            title: "Development Progress(%)",
            field: "uploadStatus",
            render: (rowData) => (
                <span style={{ color: rowData.uploadStatusColorCode }}>
                  {rowData.uploadStatus}%
                </span>
              ),
        },
        {
            title: "Last Pending With",
            field: "sender",
        },
        {
            title: "Current Pending With",
            field: "currentPendingWith",
        },
        {
            title: "Supplier Name",
            field: "supplierName",
        },
        {
            title: "Group",
            field: "groupName",
        },
        {
            title: "Product",
            field: "product",
        },
        {
            title: "Description",
            field: "description",
        },
        {
            title: "Component Engineer/Initiator",
            field: "componentEngineerInitiator",
        },
        {
            title: "Raise Date",
            field: "createdDate",
            render: (rowData) => <span>{renderDateY(rowData.createdDate)}</span>
        },
        {
            title: "Release Date",
            field: "massReleasetoSQE",
            render: (rowData) => <span>{renderDateY(rowData.massReleasetoSQE)}</span>
        },
        // {
        //  title: "Release Date",
        //  field: "revisionDate",
        //  render: (rowData) => <span>{renderDateY(rowData.revisionDate)}</span>
        // },
        {
            title: "Status",
            field: "statusName",
        }
    ]

    function ExportToExcel() {
        const dataToDownload = tableRef?.current?.dataManager?.searchedData.map(
            (row) => {

                return {
                    automatedIsirnumber: row.automatedIsirnumber,
                    spiridonNumber: row.spiridonNumber,
                    lastPendingWith: row.sender,
                    currentPendingWith: moment(row.currentPendingWith).format("YYYY-MM-DD"),
                    supplierName: row.supplierName,
                    groupName: row.groupName,
                    product: row.product,
                    description: row.description,
                    componentEngineerInitiator: row.componentEngineerInitiator,
                    requestopenedon: moment(row.requestopenedon).format("YYYY-MM-DD"),
                    revisionDate: row.revisionDate ? moment(row.revisionDate).format("YYYY-MM-DD") : "",
                    statusName: row.statusName,
                };
            }
        );
        let headers = [
            "ISIR ID",
            "Spiridon No",
            "Last Pending With",
            "Current Pending With",
            "Supplier Name",
            "Group",
            "Product",
            "Description",
            "Component Engineer/Initiator",
            "Raise Date",
            "Release Date",
            "Status",
        ];


        let ws = XLSX.utils.book_new();
        let wb = XLSX.utils.book_new();
        XLSX.utils.sheet_add_aoa(ws, [headers]);
        XLSX.utils.sheet_add_json(ws, dataToDownload, {
            origin: "A2",
            skipHeader: true,
            cellStyles: true,
        });
        const dataForCellAdjustments = dataToDownload;
        const headerObj = {

            automatedIsirnumber: headers[0],
            spiridonNumber: headers[1],
            sender: headers[2],
            supplierName: headers[3],

            requestopenedon: headers[4],
            revisionDate: headers[5],

            statusName: headers[6],
        }
        dataForCellAdjustments.push(headerObj);
        ws["!cols"] = cellAdjustToContents(dataToDownload);
        XLSX.utils.book_append_sheet(wb, ws, "List Of ISIR");
        XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(wb, " List Of ISIR.xlsx");
    }
    function cellAdjustToContents(data) {
        return [
            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.automatedIsirnumber ? c.automatedIsirnumber?.toString()?.length : 0
                    )
                ),
            },
            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.spiridonNumber ? c.spiridonNumber.toString()?.length : 0
                    )
                ),
            },
            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.sender ? c.sender.toString()?.length : 0
                    )
                ),
            },
            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.supplierName ? c.supplierName.toString()?.length : 0
                    )
                ),
            },

            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.requestopenedon ? c.requestopenedon.toString()?.length : 0
                    )
                ),
            },
            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.revisionDate ? c.revisionDate.toString()?.length : 0
                    )
                ),
            },

            {
                wch: Math.max(
                    ...data?.map((c) =>
                        c.statusName ? c.statusName.toString()?.length : 0
                    )
                ),
            },

        ];
    }
    const [tableData, setTableData] = useState([]);
    function getDetailsForIsir() {

        if (userDetails.roleId === 1) {
            setIsLoader(true);
            setIsLoaderFeedback(true);
            getAllIsirDetails(siteToken.token,
                azureToken.token,
                UID.id,
                userDetails.userEmail,
                userDetails.gid,
                userDetails.role,
                userDetails.roleId)
                .then((response) => {
                    // console.log("ISIRDETAILSFROMEPWORK", response);
                    //setIsLoader(true);
                    setTableData(response);
                    console.log('roleid=1',response)
                    setIsLoader(false);
                    setIsLoaderFeedback(false);
                    //setIsLoader(false);
                })
                .catch((error) => {
                    console.log(error);
                    setIsLoaderFeedback(false);
                    //setIsLoader(false);


                });
        }

        else if (userDetails.roleId === 3) {
            setIsLoader(true);
            setIsLoaderFeedback(true);
            getSupplierlist(siteToken.token,
                azureToken.token,
                UID.id,
                userDetails.userEmail,
                userDetails.gid,
                userDetails.role,
                userDetails.roleId, userDetails.supplierId)
                .then((response) => {
                    //setIsLoader(true);
                    setTableData(response);
                    console.log('roleid=3',response)
                    setIsLoader(false);
                    setIsLoaderFeedback(false);
                    //
                })
                .catch((error) => {
                    handleSnackOpen("Error : " + error, "error");
                    setIsLoaderFeedback(false);
                    //setIsLoader(false);
                });
        }
        else if (userDetails.roleId === 6) {
            setIsLoader(true);
            setIsLoaderFeedback(true);
            getComponentEngiDetailsList(siteToken.token,
                azureToken.token,
                UID.id,
                userDetails.userEmail,
                userDetails.gid,
                userDetails.role,
                userDetails.roleId)
                .then((response) => {

                    setTableData(response);
                    console.log('roleid=6',response)
                    setIsLoader(false);
                    setIsLoaderFeedback(false);

                })
                .catch((error) => {


                    handleSnackOpen("Error : " + error, "error");
                    setIsLoaderFeedback(false);

                });
        }
        else {
            setIsLoader(true);
            setIsLoaderFeedback(true);
            getsqeDetailsList(siteToken.token,
                azureToken.token,
                UID.id,
                userDetails.userEmail,
                userDetails.gid,
                userDetails.role,
                userDetails.roleId)
                .then((response) => {
                    //setIsLoader(true);
                    setTableData(response);
                    console.log('restroleid',response)
                    setIsLoader(false);
                    setIsLoaderFeedback(false);
                    //
                })
                .catch((error) => {
                    handleSnackOpen("Error : " + error, "error");
                    setIsLoaderFeedback(false);
                    //setIsLoader(false);
                });
        }


    };

    function getDetailsOfSupplierList() {
        setIsLoader(true);
        setIsLoaderFeedback(true);
        if (userDetails.roleId === 3) {
            setIsLoaderFeedback(true);
            getSupplierlist(siteToken.token,
                azureToken.token,
                UID.id,
                userDetails.userEmail,
                userDetails.gid,
                userDetails.role,
                userDetails.roleId, userDetails.supplierId)
                .then((response) => {
                    setTableData(response);
                    setIsLoader(false);
                    setIsLoaderFeedback(false);
                })
                .catch((error) => {
                    handleSnackOpen("Error : " + error, "error");
                    setIsLoaderFeedback(false);
                });
        }
    }
    function getDetailsByRole() {
        setIsLoader(true);
        setIsLoaderFeedback(true);
        getsqeDetailsList(siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId)
            .then((response) => {
                setTableData(response);
                setIsLoader(false);
                setIsLoaderFeedback(false);
            })
            .catch((error) => {
                handleSnackOpen("Error : " + error, "error");
                setIsLoaderFeedback(false);
            });

    }
    function getDetailsOfComponentEngi() {
        setIsLoader(true);
        setIsLoaderFeedback(true);
        getComponentEngiDetailsList(siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId)
            .then((response) => {

                setTableData(response);
                setIsLoader(false);
                setIsLoaderFeedback(false);
            })
            .catch((error) => {
                handleSnackOpen("Error : " + error, "error");
                setIsLoaderFeedback(false);
            });
    }
    const handleSnackOpen = (text, type) => {
        setSnackMessage(text);
        setAlertType(type);
        setOpen(true);
    };
    const handleClose = (e) => {
        setOpen(false);
    };

    const [kpiData, setKpiData] = useState([])
    function getKPIData() {
        setIsLoader(true);
        setIsLoaderKpi(true);
        GetISIRKPIDetails(siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId, dateInputs.fromDate, dateInputs.toDate, userDetails.supplierId, supplierFilterId, product, groupId)
            .then((response) => {
                setKpiData(response);
                console.log("KPI res", response);
                // setIsirDetailsData(response.isirData)
                setTableData(response.isirData);
                setIsLoaderKpi(false);
                setIsLoader(false);
            })
            .catch((error) => {
                handleSnackOpen("Error : " + error, "error");
                setIsLoaderKpi(false);
                setIsLoader(false);
            });
    }

    function resetFilters() {
        setDateInputs({
            fromDate: '',
            toDate: ''
        })
        setSupplierFilterId(null);
        setGroupId(null);
        setProduct('');
    }

    const [supplierData, setSupplierData] = useState([]);
    const [supplierDataNew, setSupplierDataNew] = useState([]);
    async function getSupplierDetails() {
        const response = await getSupplierDDL(siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId);
        if (response && response.length > 0) {
            setSupplierDataNew(response);
            setSupplierData(response);
        } else {
            setSupplierData([]);
        }
    }


    const [groupState, setGroupState] = useState([]);
    function groupCategory() {
        getGroupcategory(siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId)
            .then((response) => {

                setGroupState(response);

            })
            .catch((error) => {
                console.log(error);

            });
    }


    const [groupId, setGroupId] = useState(null);
    const handleChangeGroup = (e) => {
        setGroupId(e.target.value);
    }
    const [supplierFilterId, setSupplierFilterId] = useState(null);
    const handleSupplierChange = (e) => {
        setSupplierFilterId(e.target.value);
    }
    const [product, setProduct] = useState(null);
    const productTxtChange = (e) => {
        setProduct(e.target.value);
    }
    useEffect(() => {
        getDetailsForIsir();
        //getDetailsOfSupplierList();
        //getDetailsByRole();
        // getDetailsOfComponentEngi();
        getKPIData();
        getSupplierDetails();
        groupCategory();
    }, [])



    const tableOptions = {
        headerStyle: tableHeaderStyle,
        showTitle: false,
        draggable: false,
        pageSize: 10,
        pageSizeOptions: [10, 25, 50],
        paginationPosition: "bottom",
        maxBodyHeight: "600px",
        actionsColumnIndex: -1
    };

    function getProgressComponent() {
        return <CircularProgress style={{ height: `15px`, width: `15px` }} />;
    }

    return (
        <div>

            <Grid container xs={12} className="complaintsHomePage">
                <Grid item xs={12} className="left-div">
                    <h3 className="heading">List of ISIR</h3>
                </Grid>
                <Grid container className="bg-card" spacing={2} style={{ "marginBottom": "10px", "marginTop": "10px" }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink htmlFor="bootstrap-input">
                                From Date
                            </InputLabel>
                            <BootstrapInput
                                type="date"
                                id="bootstrap-input"
                                name="fromDate"
                                onChange={handleDateChange}
                                value={dateInputs.fromDate}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink htmlFor="bootstrap-input">
                                To Date
                            </InputLabel>
                            <BootstrapInput
                                type="date"
                                id="bootstrap-input"
                                name="toDate"
                                onChange={handleDateChange}
                                value={dateInputs.toDate}
                                inputProps={{ max: getTodayDateMoment }}
                            />
                        </FormControl>
                    </Grid>

                    {/* <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink htmlFor="bootstrap-input">Supplier</InputLabel>
                            <Select
                                labelId="Suppler"
                                id="supplier"
                                name="supplier"
                                onChange={handleSupplierChange}
                                value={supplierFilterId}
                                input={<BootstrapInput />}
                            >
                                {supplierData.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Grid> */}

                    {/* <Grid item xs={12} sm={6} md={3}>
                        <div className="dashboard-block">

                            <p className="dashboard-text-block d-flex jc-space-bt">
                                <span>Open Complaints Percentage&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </span>:
                                {isLoaderKpi ? (
                                    getProgressComponent()
                                ) : (
                                    <span>{kpiData?.openRequestsPercentage}</span>
                                )}
                            </p>


                            <p className="dashboard-text-block d-flex jc-space-bt">
                                <span>OverDue Complaints Percentage</span>:
                                {isLoaderKpi ? (
                                    getProgressComponent()
                                ) : (
                                    <span style={{ color: "red" }}>{kpiData?.dueRequestsPercentage}</span>
                                )}
                            </p>

                            <p className="dashboard-text-block d-flex jc-space-bt">
                                <span>Closed Complaints Percentage&nbsp;&nbsp;&nbsp;&nbsp; </span>:
                                {isLoaderKpi ? (
                                    getProgressComponent()
                                ) : (
                                    <span>{kpiData?.closeRequestsPercentage}</span>
                                )}
                            </p>

                        </div>
                    </Grid> */}

                    <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink htmlFor="bootstrap-input">Group</InputLabel>
                            <Select
                                labelId="Group"
                                id="group"
                                name="group"
                                onChange={handleChangeGroup}
                                value={groupId}
                                input={<BootstrapInput />}
                            >
                                {groupState?.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink htmlFor="bootstrap-input">Product</InputLabel>
                            <BootstrapInput
                                onChange={productTxtChange}
                                
                                value={product}
                                input={<BootstrapInput />}
                                name="Product"
                                fullWidth
                                variant="outlined"
                           
                               

                            />
                        </FormControl>
                    </Grid>


                   

                    {/*<Grid item xs={12} sm={6} md={3}>*/}
                    {/*<FormControl fullWidth>*/}
                    {/*<InputLabel shrink htmlFor="bootstrap-input">Product</InputLabel>*/}
                    {/*    <TextField*/}
                    {/*        className="mt-1"*/}
                    {/*        multiline*/}
                    {/*        value={product}*/}
                    {/*        onChange={productTxtChange}*/}
                    {/*        name="Product"*/}
                    {/*        fullWidth*/}
                    {/*        variant="outlined"*/}
                    {/*       // placeholder="Product"*/}
                    {/*    />*/}
                    {/*     </FormControl>*/}
                    {/*</Grid>*/}

                    <Grid item style={{ display: "flex" }} className="mr-btm" xs={6} sm={6} md={4} spacing={1}>
                        <Grid item xs={12}><Button className="pt-button--primary button-submit"
                            variant="contained"
                            onClick={getKPIData}
                        >
                            Filter Result
                        </Button>
                        </Grid>
                        <Grid item xs={12}> <Button className="pt-button--primary button-submit"
                            variant="contained"
                            onClick={resetFilters}
                            style={{marginLeft:'-60px'} }
                        >
                            Reset 
                        </Button>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item xs={12} className="matTable">
                    <MaterialTable
                        tableRef={tableRef}
                        actions={actions}
                        columns={columns}
                        data={tableData}
                        icons={tableIcons}
                        isLoading={isLoader}
                        options={tableOptions}
                    />
                </Grid>
            </Grid>

            <Dialog
                open={deleteDialogOpen}
                onClose={handleCloseDeleteDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="responsive-dialog-title">Delete Record</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure to Delete this Record ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleDialogRowDelete}
                        className="pt-button--primary"
                    >
                        Ok
                    </Button>
                    <Button
                        onClick={handleCloseDeleteDialog}
                        className="pt-button--secondary"
                        autoFocus
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <SnackbarCustom
                open={open}
                message={snackMessage}
                alertType={alertType}
                handleClose={handleClose}
            />

            {isLoaderFeedback ? <Loading loaderText="Loading...." /> : <></>}
        </div>
    );
}
export default Epwork;